import React from "react";
import { Gallery } from "devextreme-react";
import login1 from "../../../images/login1.png";
import login2 from "../../../images/Banner Achs Virtual (1).png";
import login3 from "../../../images/login3.jpg";

class Campanias extends React.PureComponent {
  doClickGallery = () => {
    window.open('https://www.achs.cl/portal/Paginas/informacion-importante-sobre-el-coronavirus.aspx', '_blank');
  }

  render() {
    return (
      <center>
        <div className="zero col-12" style={{ /*backgroundImage: `url(${login3})`,*/ cursor:'pointer', backgroundSize: 'cover' }}>
          {/* <Gallery
            height="100vh"
            width="100%"
            loop
            slideshowDelay={3500}
            showNavButtons
            showIndicator
            dataSource={[login1, login2,
            ]}
            stretchImages
          /> */}
          <Gallery
            height="100vh"
            width="100%"
            loop={false}
            slideshowDelay={10500}
            showNavButtons={false}
            showIndicator={false}
            dataSource={[login2]}
            stretchImages
            onItemClick={this.doClickGallery}
          />
        </div>
      </center>
    );
  }
}

export default Campanias;

